module.exports = __webpack_public_path__ + "media/stylesheets/images/media-1-mobile-ddf50a6662f86ff4a93d629b0bb698d6.jpg";